// extracted by mini-css-extract-plugin
export default {"container":"J2-z","list":"K2-z"};